/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Praefix
 * 
 * 1 = Postfix
 * 
 * 2 = All
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum TitelType {
 Praefix = 0,
 Postfix = 1,
 All = 2
}

marker([
    "Enum.TitelType.Praefix",
    "Enum.TitelType.Postfix",
    "Enum.TitelType.All"
]);

export namespace TitelType
{
    class DataSets
    {
        static TitelTypeDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Praefix", 0, "Praefix"),
            new EnumValue("Postfix", 1, "Postfix"),
            new EnumValue("All", 2, "All"),
        )
    }

    export function getAsDataset() {
        return DataSets.TitelTypeDataSet;
    }
}
